/**
 * Created by maksymkunytsia on 10/11/16.
 */

export const RECEIPT_TYPES = {
  A4: 'A4',
  EPSON: 'EPSON',
  EMAIL: 'EMAIL'
};
